import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@/store/hooks'
import entraAuthService from '@/services/entraAuthService'
import { setEntraAuthSuccess } from '@/store/slices/authSlice'
import { transformUser } from '@/utils/userTransform'

const AuthCallback: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        console.log('🔄 Auth callback component mounted')
        
        // Check if we have an active account (set by App.tsx initialization)
        const activeAccount = entraAuthService.getActiveAccount()
        const allAccounts = entraAuthService.getAllAccounts()
        
        console.log('📋 Active account:', activeAccount?.username)
        console.log('📋 All accounts:', allAccounts.length)
        
        if (activeAccount) {
          console.log('👤 Using active account for verification')
          
          try {
            // Get ID token
            console.log('🔄 Getting ID token...')
            const idToken = await entraAuthService.getTokenSilently(activeAccount)
            console.log('✅ ID token acquired')
            
            // Verify with backend
            console.log('🔄 Verifying with backend...')
            const response = await entraAuthService.verifyTokenWithBackend(idToken)
            console.log('✅ Backend verification successful:', response.user.email)
            
            // Update Redux state and wait for it to complete
            console.log('🔄 Updating Redux state...')
            const transformedUser = transformUser(response.user)
            await dispatch(setEntraAuthSuccess({
              user: transformedUser,
              token: response.token
            }))
            
            // Small delay to ensure state has propagated
            await new Promise(resolve => setTimeout(resolve, 100))
            
            // Redirect to app
            console.log('🔄 Redirecting to home page...')
            navigate('/')
            return
          } catch (tokenError) {
            console.error('❌ Token verification failed:', tokenError)
            // Clear the failed account and redirect to login
            await entraAuthService.logout()
          }
        }
        
        // If we get here, there's no valid account or token verification failed
        console.log('❌ No valid account found, redirecting to login')
        navigate('/login')
        
      } catch (error) {
        console.error('❌ Auth callback failed:', error)
        console.error('❌ Error details:', {
          name: (error as Error)?.name,
          message: (error as Error)?.message,
          stack: (error as Error)?.stack
        })
        navigate('/login')
      }
    }

    handleAuthCallback()
  }, [navigate, dispatch])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  )
}

export default AuthCallback